<template>
  <div>
  
    <div class="cpp-content">
      
      <div class="panel">
        
        <div class="notes">
          <div class="tabs">
       
            <div :class="tab =='datastructure'?'tab active':'tab'" @click="switchTab('datastructure')">数据结构</div>
            <div :class="tab =='algorithm'?'tab active':'tab'" @click="switchTab('algorithm')">基础算法</div>
            <div :class="tab =='adv'?'tab active':'tab'" @click="switchTab('adv')">高级DS/算法</div>
            
           <!-- <div :class="tab =='exercise'?'tab active':'tab'"  @click="switchTab('exercise')">习题集</div> -->
          </div>
          <div>
              <div v-for="(c,index) in datastructures" v-if="tab == 'datastructure'">
                <div @click.stop="openClass(c)"  class="class-row">{{ c.name }}
                
                   <img src="/images/open.png" style="width:20px;float:right" v-if="!c.open"/>
                   <img src="/images/close.png" style="width:20px;float:right" v-if="c.open"/>
                </div>
               

                <div v-if="c.open" style="margin-top:3px">
                  <div v-for="(s,index1) in c.topic" class="topic-row" @click="loadProject(s)">
                    <div>{{index1+1}}. {{ s.name }}</div>
                    <div>
                      <img src="/images/code.png" style="width:20px"/>
                    </div>
                  </div>
                </div>
              </div>

              <div v-for="(c,index) in algorithm" v-if="tab == 'algorithm'">
                <div @click.stop="openClass(c)"  class="class-row">{{ c.name }}
                
                   <img src="/images/open.png" style="width:20px;float:right" v-if="!c.open"/>
                   <img src="/images/close.png" style="width:20px;float:right" v-if="c.open"/>
                </div>
               

                <div v-if="c.open" style="margin-top:3px">
                  <div v-for="(s,index1) in c.topic" class="topic-row" @click="loadProject(s)">
                    <div>{{index1+1}}. {{ s.name }}</div>
                    <div>
                      <img src="/images/code.png" style="width:20px"/>
                    </div>
                  </div>
                </div>
              </div>

              <div v-for="(c,index) in adv" v-if="tab == 'adv'">
                <div @click.stop="openClass(c)"  class="class-row">{{ c.name }}
                
                   <img src="/images/open.png" style="width:20px;float:right" v-if="!c.open"/>
                   <img src="/images/close.png" style="width:20px;float:right" v-if="c.open"/>
                </div>
               

                <div v-if="c.open" style="margin-top:3px">
                  <div v-for="(s,index1) in c.topic" class="topic-row" @click="loadProject(s)">
                    <div>{{index1+1}}. {{ s.name }}</div>
                    <div>
                      <img src="/images/code.png" style="width:20px"/>
                    </div>
                  </div>
                </div>
              </div>

              <div v-for="(c,index) in exercises" v-if="tab == 'exercise'">
                <div @click.stop="openClass(c)"  class="class-row">{{ c.name }}
                
                   <img src="/images/open.png" style="width:20px;float:right" v-if="!c.open"/>
                   <img src="/images/close.png" style="width:20px;float:right" v-if="c.open"/>
                </div>
               

                <div v-if="c.open" style="margin-top:3px">
                  <div v-for="(s,index1) in c.topic" class="topic-row" @click="loadProject(s)">
                    <div>{{index1+1}}. {{ s.name }}</div>
                    <div>
                      <img src="/images/code.png" style="width:20px"/>
                    </div>
                  </div>
                </div>
              </div>

          </div>
        </div>

        
      </div>
      <div class="coder" style="width:75%;border-left:1px solid #eee; background:#eee">
        <editor v-model="code" lang="java" theme="chrome" class="editor editor-font-2" ref="aceEditor" id="codeEditor" style="border-top:1px solid #ddd"
        :options="editorOptions" 
        ></editor>

        <div class="font-setting">
          <div :class="font == 1?'item active':'item'" @click="changeFont(1)">小</div>
          <div :class="font == 2?'item active':'item'" @click="changeFont(2)">中</div>
          <div :class="font == 3?'item active':'item'" @click="changeFont(3)">大</div>
        </div>

        <div v-if="connected" style="right:130px;top:15px;position: absolute;background:green;width:12px;height:12px;border-radius:6px">&nbsp;</div>
        <div v-if="!connected" style="right:130px;top:15px;position: absolute;background:red;width:12px;height:12px;border-radius:6px">&nbsp;</div>

        <div style="position: absolute;right:160px;top:8px;">
          <input v-model="stdin" placeholder="stdin输入内容"/>
        </div>

        <button @click="saveToFile" class="btn btn-sm btn-info" style="position:absolute;right:350px;top:8px">保存代码</button>

        <div v-if="result!=null" style="z-index:1;position: absolute;left:41px;width:calc(100% - 41px);bottom:0px;background:#ccc;height:150px;padding:10px 15px;overflow: auto">
          <div v-html="result"></div>

          <div style="position: absolute;top:15px;right:15px;font-size:20px;cursor: pointer;" @click="result = null">X</div>
        </div>
      </div>
    </div>

    <div class="buttons" style="right:20px;bottom:20px">
      <button @click="copyToClipboard" class="btn btn-info" style="margin-right:10px" :disabled="running">{{ running? '运行中...':'运行程序'}}</button>
      <button @click="copyToClipboard2" class="btn btn-info" style="margin-right:10px" >复制代码</button>
    </div>

    
  </div>
</template>

<script>
import editor from 'vue2-ace-editor'
import bus from '../utils/bus';
import util from '../utils/util';
require('brace/mode/java');
require('brace/theme/chrome');



export default {
  data() {
    return {
      code: "",
      datastructures:[],
      exercises:[],
      algorithm:[],
      adv:[],
      font:2,
      connected:false,
      tab:"datastructure",
      result :null,
      stdin:"",
      running:false,
      editorOptions: {
        enableBasicAutocompletion: false,
        enableLiveAutocompletion: false,
        enableSnippets: false,
        enableLinking: false,
        foldStyle: 'manual',
      },
      socket:null,
    };
  },
  components:{
    editor
  },
  mounted() {
      this.loadList();
      setTimeout( ()=>{
        document.getElementsByClassName("ace_text-input")[0].addEventListener('paste', this.handlePaste);
      },500);
      this.connectLoop();
  },
  methods: {
    switchTab(tab){
      this.tab = tab;
    },
    copyToClipboard2(){
      var textarea = document.createElement('textarea');
          textarea.style.position = 'fixed';
          textarea.style.opacity = 0;
          textarea.value = this.code;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
    },
       copyToClipboard() {
          // var textarea = document.createElement('textarea');
          // textarea.style.position = 'fixed';
          // textarea.style.opacity = 0;
          // textarea.value = this.code;
          // document.body.appendChild(textarea);
          // textarea.select();
          // document.execCommand('copy');
          // document.body.removeChild(textarea);
          if(this.code == ''){
            return;
          }

          if(this.running ){
            return;
          }

          this.running = true;
          this.result = null;

          var postInfo = {};
          postInfo.code = encodeURIComponent(this.code);//.replace(/\n/g,'');
          postInfo.language = 7;
          postInfo.stdin = this.stdin;
          postInfo.fileext = "cpp";

          this.$http.post("https://aiapi.dctechonline.cn/api/runcode",postInfo).then(response => {
            console.log(response.data);
            this.running = false;
            this.result = response.data.output != '' ? response.data.output.replace(/\n/g, '<br>') : response.data.errors.replace(/\n/g, '<br>')
          });
      },
    connectLoop(){
      var mobile = util.getSearchString("mobile");
      var target = util.getSearchString("target");

      if(mobile != null && mobile != ""){
        if(!this.connected){
          this.connectServer();
        }

        var interval = setInterval( ()=>{
          if(!this.connected){
            this.connectServer();
          }
          else{
            clearInterval(interval);
          }
        },5000);
        
      }
      else{
        mobile = 's1';
        target = 't1';
        if(!this.connected){
          this.connectServer();
        }

        var interval = setInterval( ()=>{
          if(!this.connected){
            this.connectServer();
          }
          else{
            clearInterval(interval);
          }
        },5000);
      }
    },
    handlePaste(){
      if(this.socket != null){
        var mobile = util.getSearchString("mobile");
        var target = util.getSearchString("target");
        if(mobile == null || mobile == ""){
          mobile = 's1';
          target = 't1';
          
        }

        if(mobile == null || mobile == ""){
            return;
        }
        var sendStr = JSON.stringify({ type: 'classcode', value: this.code, target:target, from:mobile});
          try{
            this.socket.send(sendStr);
          }
          catch( err){
  
          }
      }
    },
    saveToFile() {
    const content = this.code; // 替换成你要保存的文本内容

    // 创建Blob对象
    const blob = new Blob([content], { type: 'text/plain' });

    // 创建URL对象
    const url = window.URL.createObjectURL(blob);

    // 创建a标签
    const a = document.createElement('a');
    a.href = url;
    a.download = 'code.cpp'; // 替换成你想要的文件名

   
    document.body.appendChild(a);

    // 模拟点击下载
    a.click();

    // 释放URL对象
    window.URL.revokeObjectURL(url);

    // 移除a标签
    document.body.removeChild(a);
  },
    connectServer(){
      
      var mobile = util.getSearchString("mobile");
      var target = util.getSearchString("target");

      if(mobile == null || mobile == ""){
        mobile = 's1';
        target = 't1';
        
      }
      
      const socket = new WebSocket('wss://wss.dctechonline.cn:8024');
      this.socket = socket;

      // When the connection is established
      socket.addEventListener('open', event1 => {
        console.log('WebSocket connection established.');
        
        socket.send(JSON.stringify(
          {
              type:"user",
              mobile:mobile,
              target:target,
              classType:'ds',
          }));


          var interval2 = setInterval( ()=>{
            if(this.loopCheck == false){
              
              clearInterval(interval2);
              this.connected = false;
              this.connectLoop();
              return;
            }
            else{
              socket.send(JSON.stringify(
              {
                  type:"loopcheck",
                  mobile:mobile
              }))
              this.loopCheck = false;
              console.log('check successful');
            }
          },20000);


          this.connected = true;

          socket.addEventListener('message', event => {
        // 创建一个 FileReader 对象 
          const reader = new FileReader();
  
          // 当 FileReader 加载完成后，将 Blob 转换为字符串
          reader.addEventListener('loadend', () => {
            const text = reader.result;
            const data = JSON.parse(text);
            const { type, value,from } = data;
            console.log(data);
            if (type === 'classcode' && from == target) {
              // Update the editor with the new text
              this.code = value;
            }
            else if(type ==="loopcheck"){
              this.loopCheck = true;
            }
          });
  
          // 读取 Blob 内容
          reader.readAsText(event.data);
        });
  
        // // When the editor's content changes

        if(this.$refs.aceEditor){
          this.$refs.aceEditor.$vnode.elm.children[0].addEventListener('input', event => {
          // var target = target;
            var sendStr = JSON.stringify({ type: 'classcode', value: this.code, target:target, from:mobile});
            try{
              socket.send(sendStr);
            }
            catch( err){
              // this.connected = false;
              // this.connectLoop();
            }
          
          });
        }
      });

      // When a message is received from the server
      
    },
    openClass(c){
      if(c.open){
        c.open = false;
      }
      else{
        c.open = true;
      }
    },
    changeFont(f){
      this.font = f;
      if(f == 1){
        $("#codeEditor").removeClass("editor-font-1");
        $("#codeEditor").removeClass("editor-font-2");
        $("#codeEditor").removeClass("editor-font-3");
        $("#codeEditor").addClass("editor-font-1");
      }
      else if(f == 2){
      
        $("#codeEditor").removeClass("editor-font-1");
        $("#codeEditor").removeClass("editor-font-2");
        $("#codeEditor").removeClass("editor-font-3");
        $("#codeEditor").addClass("editor-font-2");
      
      }
      else if(f == 3){
        $("#codeEditor").removeClass("editor-font-1");
        $("#codeEditor").removeClass("editor-font-2");
        $("#codeEditor").removeClass("editor-font-3");
        $("#codeEditor").addClass("editor-font-3");
      }
    },
    loadList(){
     
      var r = new Date().getTime();
      this.$http.get("/data/ds/ds.json?random="+r).then(response => {
        this.datastructures = response.data;
      });

      this.$http.get("/data/ds/algorithm.json?random="+r).then(response => {
        this.algorithm = response.data;
      });

      this.$http.get("/data/ds/exercises.json?random="+r).then(response => {
        this.exercises = response.data;
      });

      this.$http.get("/data/ds/adv.json?random="+r).then(response => {
        this.adv = response.data;
      });
    },
    loadProject(p){
         var r = new Date().getTime();
        this.$http.get(p.path+"?random="+r, { responseType: 'arraybuffer' }).then(response => {
          const decoder = new TextDecoder('utf-8'); // 指定字符编码为utf-8
          const content = decoder.decode(response.data); // 将二进制数据转换为字符串
          this.code = content;
        }).catch(error => {
         
        });
    },
    
  
  },
};
</script>

<style lang="scss">

.cpp-content{
  position: fixed;
  top:56px;
  left:0px;
  width:100%;
  height:calc(100% - 56px);
  display: flex;

  .coder{
    width:75%;
    height:100%;
    overflow: auto;
    position: relative;

    .editor{
      width:100%;
      height:calc(100% - 46px) !important;
      margin-top:46px;
      background:#f5fdfb;

      .ace_print-margin{
        display: none;
      }

      &.editor-font-1{
        font-size: 12px !important;
      }

      &.editor-font-2{
        font-size: 14px !important;
      }

      &.editor-font-3{
        font-size: 16px !important;
      }
    }


    .font-setting{
      position: absolute;
      right:10px;
      top:10px;
      display: flex;
      border: 1px solid #eee;

      .item{
        width:35px;
        text-align: center;
        font-size:14px;
        background:white;
        cursor: pointer;

        &.active{
          background:#04b2c5;
          color:white;
        }
      }
    }
  }
  .panel{
    width:25%;
    border-left:none !important;
    .result{
      width:100%;
      height:50%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      border-bottom:1px solid #eee;

      .title{
        position: absolute;
        top:0px;
        left:0px;
        width:100%;
        padding:10px;
        font-weight:bold;
        font-size:14px;
      }
      canvas{
        max-width:100%;
        max-height:100%;
      }
    }

    .notes{
      width:100%;
      height:100%;
      //background:black;
      overflow: auto;

      .tabs{
        display: flex;
        
        font-size:14px;
        justify-content: space-around;
        .tab{
          width:50%;
          text-align: center;
          padding:10px 0px;
          cursor: pointer;
          border-bottom: 1px solid #eee;;
          
          &.active{
            background: #8fbc8f !important;
            
            color:white;
          }
        }
      }
    }
  }
}

.buttons{
  position: fixed;
  bottom:10px;
  right:41%;
  z-index: 10;
}

.ace_gutter-cell.error-line{
  background:orangered;
  color:white;
}


.ace_gutter-cell .ace_fold-widget{
  display: none !important
}


// .ace_gutter-cell{
//   height:18px !important;
//   line-height:18px !important;
// }

// .ace_line{
//   height:18px !important;
//   line-height:18px !important;
// }
// .ace_gutter-active-line{
//   height:18px !important;
//   line-height:18px !important;
// }
// .ace_cursor{
//   height:18px !important;
//   line-height:18px !important;
// }

.pjsconsole{
  width:60%;
  height:150px !important;
  .console{
    overflow-y: auto !important;
    height:150px !important;
    padding-bottom:20px;
  }
}

.project-row{
  display:flex;
  justify-content: space-between;
  padding:5px 10px;
  font-size:15px;
  cursor: pointer;

  &:hover{
    background:#eee;
  }
}

.class-row{
  padding:5px 10px;
  font-size:15px;
  cursor: pointer;

  &:hover{
    background:#eee;
  }
}

.topic-row{
  cursor: pointer;
  font-size:13px;
  padding:3px 20px;
  padding-right:8px;
  display: flex;
  color:#666;
  justify-content: space-between;

  &:hover{
    background:#eee;
  }
}

.error-layer{
  position: fixed;
  bottom:0px;
  height:180px;
  left:0px;
  width:60%;
  background:#eee;
  border-top:1px solid #ccc;
}
.ace_identifier{
  color:rgb(189, 60, 1);

}

.ace_numeric{
  color:#038795 !important;
}

.ace_keyword{
  color:rgb(43, 90, 1) !important;

}
</style>